export default __webpack_public_path__ + "static/media/tripadvisor_icon.127150cc.svg";